import {
  normalizeAgentExecutionStatus,
  normalizeAgentExecutionTriggerType,
  normalizeAgentFlowStatus,
  normalizeAgentPlatformScope,
  normalizeAgentResourceVisibility,
  normalizeAgentStatus,
  normalizeAgentToolType,
  normalizeAgentType,
} from './agentPlatformEnumNormalize';

const agentStatusLabels = {
  Draft: 'Rascunho',
  Active: 'Ativo',
  Paused: 'Pausado',
  Archived: 'Arquivado',
} as const;

const agentTypeLabels = {
  AI: 'IA',
  Automation: 'Automação',
  Hybrid: 'Híbrido',
} as const;

const flowStatusLabels = {
  Draft: 'Rascunho',
  Active: 'Ativo',
  Archived: 'Arquivado',
} as const;

const executionStatusLabels = {
  Pending: 'Pendente',
  Running: 'Em execução',
  WaitingExternal: 'Aguardando externo',
  Completed: 'Concluída',
  Failed: 'Falhou',
  Cancelled: 'Cancelada',
} as const;

const toolTypeLabels = {
  Http: 'HTTP',
  Sql: 'SQL',
  Knowledge: 'Conhecimento',
  Automation: 'Automação',
  Builtin: 'Integrada',
} as const;

const scopeLabels = {
  System: 'Sistema',
  Tenant: 'Cliente',
} as const;

const visibilityLabels = {
  Internal: 'Interno',
  Configurable: 'Configurável',
  AgentTool: 'Ferramenta do agente',
} as const;

const triggerTypeLabels = {
  User: 'Usuário',
  Schedule: 'Agendado',
  Event: 'Evento',
  Agent: 'Agente',
} as const;

export function labelAgentStatus(status: unknown): string {
  const key = normalizeAgentStatus(status);
  return agentStatusLabels[key];
}

export function labelAgentType(type: unknown): string {
  const key = normalizeAgentType(type);
  return agentTypeLabels[key];
}

export function labelFlowStatus(status: unknown): string {
  const key = normalizeAgentFlowStatus(status);
  return flowStatusLabels[key];
}

export function labelExecutionStatus(status: unknown): string {
  const key = normalizeAgentExecutionStatus(status);
  return executionStatusLabels[key];
}

export function labelAgentToolType(toolType: unknown): string {
  const key = normalizeAgentToolType(toolType);
  return toolTypeLabels[key];
}

export function labelAgentPlatformScope(scope: unknown): string {
  const key = normalizeAgentPlatformScope(scope);
  return scopeLabels[key];
}

export function labelAgentResourceVisibility(visibility: unknown): string {
  const key = normalizeAgentResourceVisibility(visibility);
  return visibilityLabels[key];
}

export function labelExecutionTriggerType(trigger: unknown): string {
  const key = normalizeAgentExecutionTriggerType(trigger);
  return triggerTypeLabels[key];
}

function resolveStatusKey(
  status: unknown,
  kind: 'agent' | 'flow' | 'execution' = 'agent'
): string {
  if (typeof status === 'boolean') {
    return status ? 'Active' : 'Paused';
  }

  switch (kind) {
    case 'flow':
      return normalizeAgentFlowStatus(status);
    case 'execution':
      return normalizeAgentExecutionStatus(status);
    default:
      return normalizeAgentStatus(status);
  }
}

export function statusBadgeClass(
  status: unknown,
  kind: 'agent' | 'flow' | 'execution' = 'agent'
): string {
  const key = resolveStatusKey(status, kind);

  switch (key) {
    case 'Active':
    case 'Completed':
      return 'bg-green-100 text-green-800';
    case 'Draft':
    case 'Pending':
    case 'Running':
    case 'WaitingExternal':
      return 'bg-amber-100 text-amber-800';
    case 'Failed':
      return 'bg-red-100 text-red-800';
    case 'Paused':
    case 'Cancelled':
    case 'Archived':
      return 'bg-gray-100 text-gray-700';
    default:
      return 'bg-slate-100 text-slate-700';
  }
}
